import { RefundPolicySection } from './types'

export const refundPolicyData: RefundPolicySection[] = [
  {
    id: 1,
    title: 'Overview',
    content: [
      'At PixieWorld, we want you to be completely satisfied with your purchase. This Refund Policy outlines the terms under which you may request a refund for our products and services.',
      'Please note that our personalised stories are crafted with care, and this policy outlines how any quality concerns are handled.',
    ],
  },
  {
    id: 2,
    title: '30-Day Money-Back Guarantee — Digital Purchases',
    content: [
      'We offer a 30-day money-back guarantee on digital purchases (software access, unlimited plans, credit packs, and digital storybooks).',
      'If you are not completely satisfied, you may request a full refund within 30 days of the original purchase date — no questions asked.',
      'This guarantee applies once per customer and covers digital products only. Physical books are covered by a separate damage guarantee (see below).',
    ],
  },
  // {
  //   id: 3,
  //   title: 'Illustration Quality',
  //   content: [
  //     'Our stories are crafted with hand-illustrated artwork. Please review the following guidelines to understand what is and is not covered.',
  //     'Cosmetic variations (NOT eligible for refund):',
  //     '• Small formatting differences between pages',
  //     '• Subtle background inconsistencies',
  //     'Major defects (eligible for credit refund or replacement):',
  //     '• Wrong character appearing throughout the story',
  //     '• Missing or blank pages',
  //     '• Story not matching the selected theme or character at all',
  //     'If you experience a major defect, please contact our support team for a replacement or refund.',
  //   ],
  // },
  {
    id: 4,
    title: '7-Day Damage Guarantee — Personalized Physical Books',
    content: [
      'Due to the personalized nature of our printed storybooks, we cannot accept returns for change of mind.',
      'If your book arrives damaged or with a major defect, please contact us within 7 days of delivery with photos. We will assess each case individually and offer a replacement or refund at our discretion.',
      'Damage claims made more than 7 days after delivery are not eligible for refund or replacement.',
    ],
  },
  {
    id: 5,
    title: 'How to Request a Refund',
    content: [
      'To request a refund, please contact our support team:',
      '• Email: support@pixie.education',
      'Please include your order number and a brief description of the reason for your request. For damaged physical books, please attach photos of the damage.',
    ],
  },
  {
    id: 6,
    title: 'Refund Processing',
    content: [
      'Once your refund request is approved:',
      '• Refunds are processed within 5–10 business days.',
      '• The refund will be issued to the original payment method used at checkout.',
      '• Depending on your bank or payment provider, it may take an additional 3–5 business days for the refund to appear on your statement.',
    ],
  },
  {
    id: 7,
    title: 'Exceptions',
    content: [
      'Refunds may not be granted in the following circumstances:',
      '• Digital refund requests made more than 30 days after the original purchase date.',
      // '• Credits that have already been fully consumed to generate content with no major defects.',
      // '• Cosmetic variations as described in Section 3.',
      '• Physical book issues reported more than 7 days after delivery.',
      '• Fraudulent or abusive refund requests.',
    ],
  },
  {
    id: 8,
    title: 'Contact Us',
    content: [
      'If you have any questions about our Refund Policy, please reach out to us:',
      'Email: support@pixie.education',
    ],
  },
]
